module.exports = __webpack_public_path__ + "img/remurinn.32932d7b.jpg";